export enum CompanyStatusEnum {
  ACTIVE = 'active',
  ARCHIVED = 'archived',
  DISABLED = 'disabled',
}
